import { PublicUserResponse } from "@authory-packages/core";
import { AuthenticatedUser } from "../types/user";

export const getDisplayName = (author: AuthenticatedUser | PublicUserResponse) =>
    !!author?.displayName ? author.displayName : !author?.lastName ? `${author?.firstName}` : `${author?.firstName} ${author?.lastName}`;
export const getFirstName = (author: AuthenticatedUser | PublicUserResponse) => (!!author?.displayName ? author.displayName : author?.firstName);
export const getAuthorName = (author: AuthenticatedUser | PublicUserResponse) =>
    !author?.lastName ? `${author?.firstName}` : `${author?.firstName} ${author?.lastName}`;
